// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:45:04+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            098465ba842e1b1d4458d294031fde4b
//    Signature:      eyJpdiI6IkNGUE51YzFTOUpKUXpCVzZKcHVabEE9PSIsInZhbHVlIjoiRk56bEFkcStyNDlhWDhZREVuZ1NjWEZFTXRlVFwvUzBKeWxCXC9LampwN2dHWWRaRWdPYnpTSWFJUklrUnNmemhEalB1SHZIYzNWOHhRYXNHd3U2NVJNV013UENvZ2FKaVZ0VDA2VUswa0ZCVGVLdDF5K1wvM29kZUZZN0dyb3pFT1ZaZThFbjRFY080cHpcL2tuWjdpcjhEOXRISjFMaU40Z1U5Z0lcLzhPSnFcL3g2ZVR3R1RaSkhXdjY0cnhnU01TM1BEcFdubTIyanQ0SmgzamlQR09BckVXTFdydmZWaFMwalVDazE5bEx5YnpmWjY3ZCtRZlhPajh6SXdjV091TzBUSVdDY3BUampaZVFpdHkwd3VUdmRCYkoxTk9JWEptVTBvdmhXQTNsU2xTdTRnM3hlbktaOThkNVJzRUhUYm5LZ3hwaXlHUHpxZFhRUGZVcFByaW5ITDREYXNuNXYzeEFIV2srUTJORUsrSlRVdkxZSDRwZWMwQnZTQ1p0Rmlpc1ROWGp0Z1ZXbUlYb1lDXC9HaGdcL2lDaTNnPT0iLCJtYWMiOiJmYjJjMjMwZTE0NDk3NjJlYzAxNzAyODJiYTk1NmQ3N2VkOTJkMzYwYjQ3NGVjZDFkYTFkN2FmN2ZlMGQwMWQxIn0=
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
